<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $tc("customer", 2) }}</div>
      <!-- <router-link
        v-if="cinema_manager_add_edit_disabled != 3"
        class="btn-blue"
        to="add-Customers"
        >{{ $t("add") }}</router-link
      > -->
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div
        class="d-flex align-item-center justify-content-center"
        style="gap: 15px"
      >
        <!-- v-debounce:500="clearSearch" -->
        <b-form-input
          v-model="searchValue"
          :placeholder="$tc('search')"
        ></b-form-input>
        <!-- @click="resetList" -->
        <div
          @click="searchresetList"
          class="btn btn-secondary d-flex align-item-center justify-content-center"
        >
          Search
        </div>
      </div>
      <div class="d-flex"></div>

      <!-- Transaction Date From-->
      <div class="col-lg-4 col-xl-2 align-self-center mb-2">
        <div class="input-material">
          <div class="add-datepicker">
            <button
              class="btn-clearDate"
              v-if="fromDate"
              v-on:click="clearDate()"
            >
              ✖
            </button>
            <Datepicker
              :monday-first="true"
              type="date"
              ref="programaticOpen"
              v-model="fromDate"
              @selected="onChangeDate($event, 'from')"
              v-validate="'required'"
            ></Datepicker>
            <label :class="fromDate ? 'active' : ''">
              <!-- {{ $t("show") }} -->
              {{ $t("fromdate") }}
            </label>
          </div>
        </div>
      </div>
      <div></div>
      <div class="col-lg-4 col-xl-2 align-self-center mb-2">
        <div class="input-material">
          <div class="add-datepicker">
            <button
              class="btn-clearDate"
              v-if="toDate"
              v-on:click="clearDate()"
            >
              ✖
            </button>
            <!-- :disabledDates="{
                from: new Date(
                  moment(fromDate)
                    .add(31, 'd')
                    .format('YYYY-MM-DD')
                ),
              }" -->
            <Datepicker
              :monday-first="true"
              ref="programaticOpen"
              v-model="toDate"
              v-validate="'required'"
            >
            </Datepicker>
            <label :class="toDate ? 'active' : ''">
              <!-- {{ $t("show") }}  -->
              {{ $t("todate") }}</label
            >
          </div>
        </div>
      </div>

      <button
        @click="resetList"
        class="btn-blue-lg mb-2 mr-2"
        style="height: 35px"
      >
        Fetch
      </button>
      <b-dropdown
        :text="filter_is_active_label"
        variant="dropdown-curve"
        class="ml-auto mr-3 filter-status-dropdown mb-2"
      >
        <!-- <b-dropdown-item @click="onChangeFilterIsActive('')">All User</b-dropdown-item> -->
        <b-dropdown-item @click="onChangeFilterIsActive('N')"
          >Customer List</b-dropdown-item
        >
        <b-dropdown-item @click="onChangeFilterIsActive('Y')"
          >Guest List</b-dropdown-item
        >
      </b-dropdown>
      <b-dropdown
        :text="isGuestCustActive == 'Y' ? 'Active' : 'Inactive'"
        variant="dropdown-curve"
        class="ml-auto mr-3 filter-status-dropdown mb-2"
      >
        <!-- <b-dropdown-item @click="onChangeFilterIsActive('')">All User</b-dropdown-item> -->
        <b-dropdown-item @click="onChangeGuestCustActive('Y')"
          >Active</b-dropdown-item
        >
        <b-dropdown-item @click="onChangeGuestCustActive('N')"
          >Inactive</b-dropdown-item
        >
      </b-dropdown>
      <!-- <b-dropdown
        :text="is_transaction_filter_label"
        variant="dropdown-curve"
        class=" mr-3 filter-status-dropdown"
        style="width:200px"
      >
        <b-dropdown-item @click="onChangeFilterIsActiveOnlyTransaction('')"
          >All Transaction</b-dropdown-item
        >
        <b-dropdown-item @click="onChangeFilterIsActiveOnlyTransaction(1)"
          >With Transaction</b-dropdown-item
        >
        <b-dropdown-item @click="onChangeFilterIsActiveOnlyTransaction(2)"
          >Without Transaction</b-dropdown-item
        >
      </b-dropdown> -->

      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown
          :onSelect="filterIsActive => getCustomersList(filterIsActive)"
        /> -->
        <div class="mx-2">
          <b-dropdown
            name="listview"
            id="listview"
            variant="outline-blue"
            class="mb-2"
          >
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <div class="d-flex align-items-center mb-2" style="float: right">
        Download as:
        <a @click="excelDownload()" title="Download as Excel">
          <img
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </a>
      </div>
    </div>
    <!---Excel Export Start-->
    <div>
      <table class="list-view-table d-none" ref="exportable_table">
        <thead>
          <tr>
            <th>
              <!-- <img
                v-if="this.columnName != 'first_name'"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('first_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              /> -->
              {{ $tc("customer", 1) }}
            </th>
            <th class="text-left">{{ $t("mobileno") }}</th>
            <th class="text-left">{{ $t("email") }}</th>
            <th class="text-left">{{ "Wallet Balance" }}</th>
            <th class="text-left">{{ "No of Transaction" }}</th>
            <th class="text-left">{{ "Last Transaction Date" }}</th>
            <th class="text-left">{{ $t("is Guest User") }}</th>
            <!-- <th class="text-center">{{ $t("No of Transaction") }}</th> -->

            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-if="customerCopy.length > 0">
          <tr
            v-for="(customer, customerIndex) in customerCopy"
            :key="customerIndex"
          >
            <td class="text-left ml-auto">
              <div>
                {{ customer.first_name }}&nbsp;{{
                  customer.last_name == "-" ? "" : customer.last_name
                }}
              </div>
            </td>
            <td class="text-left">{{ customer.cust_mobile }}</td>
            <td class="text-left">{{ customer.cust_email || "-" }}</td>
            <td class="text-left">
              {{ customer.wallet_balance || "-" }}&nbsp;&nbsp;<span
                v-if="customer.is_guest_user == 'N'"
                class="icon-eye"
                @click="viewWalletDetails(customer)"
              ></span>
            </td>
            <td>{{
              customer.no_of_transaction || customer.booking_count || 0
            }}</td>
            <td>
              {{
                moment(customer.transaction_created).format("YYYY-MM-DD") || "-"
              }}
            </td>
            <td class="text-left">
              <div class="">{{ customer.is_guest_user || "-" }}</div>
            </td>
            <!-- <td class="text-right">{{ customer.no_of_transaction }}</td> -->
            <td>
              <!-- {{customer.cust_is_active ? 'Active' : 'Inactive'}} -->
              Active
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <label class="ios-switch">
                  <input
                    :checked="customer.cust_is_active == 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <!-- <StatusDot :status="'active'" />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="customer.is_guest_user == 'N'"
                    v-on:click="onEditCustomer(customer)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="onViewCustomer(customer)"
                    v-if="customer.is_guest_user == 'N'"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="goToFlow(customer.cust_id)"
                    v-if="customer.is_guest_user == 'N'"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("userJourneyFlow") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="gotoNewTransaction(customer)">
                    <span class="icon-eye"></span>
                    View Transactions
                  </b-dropdown-item>
                </b-dropdown> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!---Excel Export End-->

    <div style="overflow-x: scroll !important; width: auto !important">
      <table class="list-view-table" style="white-space: nowrap">
        <thead>
          <tr>
            <th class="text-center">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <!-- <img
                v-if="this.columnName != 'first_name'"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('first_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              /> -->
              {{ $tc("customer", 1) }}
            </th>
            <th class="text-left pl-2">{{ "Name" }}</th>
            <th class="text-left pl-2">{{ $t("mobileno") }}</th>
            <th class="text-left pl-2">{{ $t("email") }}</th>

            <th class="text-left pl-2">{{ "Loyalty Points" }}</th>
            <th class="text-left pl-2">{{ "Wallet Balance" }}</th>
            <th class="text-center pl-2">{{ "DOJ" }}</th>
            <th class="text-left pl-2">{{ "Gender" }}</th>
            <th class="text-left pl-2">{{ "Last Date (TRN)" }}</th>
            <th class="text-left pl-2">{{ "Count (TRN)" }}</th>
            <!-- <th class="text-left pl-2">{{ $t("is Guest") }}</th> -->
            <!-- <th class="text-center">{{ $t("No of Transaction") }}</th> -->
          </tr>
        </thead>
        <tbody v-if="customers.length > 0">
          <tr
            v-for="(customer, customerIndex) in customers"
            :key="customerIndex"
          >
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot :status="'active'" />

                <div
                  v-b-tooltip="'View Transactions'"
                  tabindex="0"
                  class="blue-icon cursor-pointer ml-2"
                  @click.prevent.stop="gotoNewTransaction(customer)"
                >
                  <svg
                    width="16"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="0" y="0" width="16" height="16" fill="#FFFFE0" />

                    <rect
                      x="1"
                      y="1"
                      width="14"
                      height="14"
                      fill="#8d6fbf"
                      stroke="#000000"
                      stroke-width="0.5"
                    />

                    <line
                      x1="2"
                      y1="4"
                      x2="14"
                      y2="4"
                      stroke="#000000"
                      stroke-width="0.5"
                    />
                    <line
                      x1="2"
                      y1="6"
                      x2="14"
                      y2="6"
                      stroke="#000000"
                      stroke-width="0.5"
                    />
                    <line
                      x1="2"
                      y1="8"
                      x2="14"
                      y2="8"
                      stroke="#000000"
                      stroke-width="0.5"
                    />

                    <path
                      d="M2,2 A1,1 0 0,1 3,3"
                      fill="none"
                      stroke="#000000"
                      stroke-width="0.5"
                    />
                    <path
                      d="M2,3 A1,1 0 0,1 3,2"
                      fill="none"
                      stroke="#000000"
                      stroke-width="0.5"
                    />
                  </svg>
                </div>
                <div class="ml-2" v-b-tooltip="'Edit Customer'" tabindex="0">
                  <i
                    v-if="customer.is_guest_user == 'N'"
                    class="edit-pen icon blue-icon cursor-pointer"
                    @click.prevent.stop="onEditCustomer(customer)"
                  ></i>
                </div>
                <div class="ml-2" v-b-tooltip="'View Customer'" tabindex="0">
                  <i
                    class="icon-eye blue-icon cursor-pointer"
                    @click.prevent.stop="onViewCustomer(customer)"
                    v-if="customer.is_guest_user == 'N'"
                  ></i>
                </div>
                <div
                  v-b-tooltip="'User Journey Flow'"
                  tabindex="0"
                  class="blue-icon cursor-pointer ml-2"
                  @click.prevent.stop="goToFlow(customer.cust_id)"
                  v-if="customer.is_guest_user == 'N'"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="#8d6fbf"
                    class="bi bi-person-fill"
                    viewBox="0 0 18 18"
                  >
                    <path
                      d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                    />
                  </svg>
                </div>
              </div>
            </td>
            <td class="text-center">
              <!-- <div class="">{{ customer.is_guest_user || "-" }}</div> -->
              <div class="">
                {{ customer.is_guest_user === "N" ? "Registered" : "Guest" }}
              </div>
            </td>
            <td class="text-left pl-2 ml-auto">
              <div>
                {{ customer.first_name }}&nbsp;{{
                  customer.last_name == "-" ? "" : customer.last_name
                }}
              </div>
            </td>
            <td class="text-left pl-2">{{ customer.cust_mobile }}</td>
            <td class="text-left pl-2">{{ customer.cust_email || "-" }}</td>

            <td class="text-right pl-2">
              {{ currFormat(customer.loyality_points || 0) }}&nbsp;&nbsp;<span
                v-if="customer.is_guest_user == 'N'"
                class="icon-eye"
                @click="viewCustomerBoxOffice(customer)"
              ></span>
            </td>
            <td class="text-right pl-2">
              {{ customer.wallet_balance || "-" }}&nbsp;&nbsp;<span
                v-if="customer.is_guest_user == 'N'"
                class="icon-eye"
                @click="viewWalletDetails(customer)"
              ></span>
            </td>
            <td class="text-left pl-2">
              {{
                moment(
                  customer.created_at ? customer.created_at : customer.cust_doj
                ).format("DD/MM/YYYY") || "-"
              }}
            </td>
            <td class="text-center pl-2">{{ customer.gender || "-" }}</td>
            <td class="text-left pl-2">
              {{
                customer.transaction_created
                  ? moment(customer.transaction_created).format("YYYY-MM-DD")
                  : "-"
              }}
            </td>
            <td class="text-right pl-2">
              {{ customer.no_of_transaction || customer.booking_count || 0 }}
            </td>
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end"> -->
            <!-- <label class="ios-switch">
                  <input
                    :checked="customer.cust_is_active == 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
            <!-- <StatusDot :status="'active'" /> -->

            <!-- <div class="d-flex align-items-center">
                  <div
                      v-on:click="onViewCustomer(customer)"
                    v-if="customer.is_guest_user == 'N'"
                    class="icon-eye blue-icon btn"
                  
                  ></div>
                  <div
                    v-if="customer.is_guest_user == 'N'"
                    v-on:click="onEditCustomer(customer)"
                    class="edit-pen blue-icon mx-2 btn"
                   
                  ></div>
              
                </div>  -->
            <!-- <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="customer.is_guest_user == 'N'"
                    v-on:click="onEditCustomer(customer)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="onViewCustomer(customer)"
                    v-if="customer.is_guest_user == 'N'"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="goToFlow(customer.cust_id)"
                    v-if="customer.is_guest_user == 'N'"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("userJourneyFlow") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="gotoNewTransaction(customer)">
                    <span class="icon-eye"></span>
                    View Transactions
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="4">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="customers.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import MarketingService from "@/services/MarketingService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import * as XLSX from "xlsx";

  import { createQueryString } from "@/services/ApiHelper";
  import { BASEURL } from "@/config/index";
  import { CLIENT_NAME } from "@/helper/Role";

  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
      NoRecords,
    },
    data() {
      return {
        includeGuests: "N",
        isGuestCustActive: "Y",
        // card_id: "",
        // card_type: "",
        // bank_id: "",

        // bank_name: "",
        fromDate: null,
        toDate: null,
        social_login_details: {},
        guestcustomers: [],
        customers: [],
        customerCopy: [],
        filter_is_active_label: "Customer List",
        filter_is_cust_guest_active_label: "Customer List",
        perPage: 10,
        currentPage: 1,
        rows: 0,
        guestRows: 0,
        selectedvalue: "10",
        viewingnumbers: [
          // { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ],

        //Sorting data
        isSort: false,
        isAscending: true,
        orderby: "",
        columnName: "",

        debounce: null,
        searchValue: "",
        listType: "",
        filterType: 1,
        is_transaction_filter: "",
        is_transaction_filter_label: "All Transaction",
      };
    },
    beforeMount() {
      this.cinema_manager_add_edit_disabled = this.secureStore.get(
        "USINFO"
      ).role_id;
      // this.getCustomersList();
      // this.onViewOffer();
      // this.onEditInstitute();
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },

    methods: {
      moment,
      clearDate() {
        this.fromDate = "";
        this.toDate = "";
        this.currentPage = 1;

        this.getCustomersList();
      },

      onChangeDate(e, type) {
        console.log("onChangeDate", type);
        if (type == "from") {
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },
      clearSearch(event) {
        if (!this.searchValue) {
          // this.searchValue = "";
          this.getCustomersList();
        }
      },
      viewCustomerBoxOffice(customer) {
        if (customer && customer.is_guest_user == "N" && customer.cust_id) {
          this.$router.push({
            // path: `/marketing/view-customer-loyalty-points?clp_id=${customer.cust_id}&type=boxoffice`
            path: `/marketing/customer-loyalty-points?customer_id=${customer.cust_id}`,
          });
        }
      },
      viewWalletDetails(customer) {
        if (customer && customer.is_guest_user == "N" && customer.cust_id) {
          this.$router.push({
            path: `/marketing/e-wallet?cust_id=${customer.cust_id}`,
          });
        }
      },
      excelDownload() {
        try {
          let payload = {
            searchValue: this.searchValue,
            user_type: this.listType,
            transaction_type: this.is_transaction_filter,
            filter_is_active: "Y",
            orderby: this.orderby,
            fromDate: this.fromDate ? this.fromDate : "",
            toDate: this.toDate ? this.toDate : "",
            includeGuests: this.includeGuests || "",
          };
          let qs = createQueryString(payload);

          let loader = this.$loading.show();
          // this.customers = [];
          MarketingService.getAllCustomerGuestListExcelNew(qs)
            .then((response) => {
              // console.log("response :", response);
              const { data } = response;
              window.open(data.excelPath, "_blank");
              console.log("data", data);
            })
            .catch((err) => {
              console.log("Error", err);
            })
            .finally(() => {
              loader.hide();
            });
          // window.open(
          //   `${BASE_URL}/api/marketing/view-guest-customers-excel${qs}`
          // );
        } catch (err) {
          console.log("Error:", err);
        }
      },
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, { sheet: "Customer" });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(wb, fn || "Customer." + (type || "xlsx"));
      },
      searchresetList() {
        // let loader = this.$loading.show();
        this.isSort = false;
        this.isAscending = true;
        this.isAscending = true;
        this.orderby = "";
        this.columnName = "";
        this.currentPage = 1;

        // this.showCustomers();
        if (this.searchValue) {
          this.getCustomersList((this.includeGuests = "Y"));
        }

        // setTimeout(() => loader.hide(), 100);
      },
      resetList() {
        // let loader = this.$loading.show();
        this.isSort = false;
        this.isAscending = true;
        this.isAscending = true;
        this.orderby = "";
        this.columnName = "";
        this.currentPage = 1;

        // this.showCustomers();

        this.getCustomersList((this.includeGuests = "N"));
        // setTimeout(() => loader.hide(), 100);
      },
      showCustomers() {
        let endVal = this.perPage;
        let startVal = this.currentPage;
        if (this.currentPage > 1) {
          startVal = this.perPage * (this.currentPage - 1);
        } else {
          startVal = 0;
        }
        endVal = startVal + this.perPage;
        console.log(startVal, endVal, this.customerCopy.length, this.listType);
        let tempVal = [...this.customerCopy];

        if (this.searchValue) {
          let loader = this.$loading.show();
          let search_value = this.searchValue.toLowerCase();
          tempVal = tempVal.filter((x) => {
            let cust_name = x.cust_name
              ? x.cust_name.toLowerCase().includes(search_value)
              : false;
            let cust_email = x.cust_email
              ? x.cust_email.toLowerCase().includes(search_value)
              : false;
            let cust_mobile = x.cust_mobile
              ? x.cust_mobile.toLowerCase().includes(search_value)
              : false;
            let checkCustomer = this.listType
              ? x.is_guest_user.toLowerCase() == this.listType.toLowerCase()
              : true;
            let is_transaction =
              this.is_transaction_filter == 1
                ? x.no_of_transaction > 0
                : this.is_transaction_filter == 2
                ? x.no_of_transaction == 0
                : true;
            console.log(x.is_guest_user, this.listType, checkCustomer);
            setTimeout(() => loader.hide(), 100);
            return (
              (cust_name || cust_email || cust_mobile) &&
              checkCustomer &&
              is_transaction
            );
          });
        } else if (this.listType) {
          let loader = this.$loading.show();

          tempVal = tempVal.filter((x) => {
            let checkCustomer = this.listType
              ? x.is_guest_user.toLowerCase() == this.listType.toLowerCase()
              : true;
            let is_transaction =
              this.is_transaction_filter == 1
                ? x.no_of_transaction > 0
                : this.is_transaction_filter == 2
                ? x.no_of_transaction == 0
                : true;
            loader.hide();
            return checkCustomer && is_transaction;
          });
        } else if (this.is_transaction_filter) {
          let loader = this.$loading.show();
          tempVal = tempVal.filter((x) => {
            let is_transaction =
              this.is_transaction_filter == 1
                ? x.no_of_transaction > 0
                : this.is_transaction_filter == 2
                ? x.no_of_transaction == 0
                : true;
            loader.hide();
            return is_transaction;
          });
        }
        if (tempVal.length > 0) {
          if (tempVal.length >= this.perPage) {
            this.selectedvalue = this.perPage;
          } else {
            this.selectedvalue = tempVal.length;
          }
          this.rows = tempVal.length;
          let showMovies_data = _(tempVal)
            // .orderBy(['Name'], ['asc']) // sort by ascendind
            .drop(startVal) // page in drop function starts from 0
            .take(this.perPage) // limit 2
            .value();
          // var showMovies_data=tempVal.splice(startVal,endVal)
          this.customers = showMovies_data;
        } else {
          this.customers = [];
          this.selectedvalue = 0;
          this.rows = 0;
        }
      },

      onChangeFilterIsActive(type) {
        this.listType = type;
        if (type == "Y") {
          this.filter_is_active_label = "Guest List";
        } else if (type == "N") {
          this.filter_is_active_label = "Customer List";
        } else {
          this.filter_is_active_label = "All User";
        }

        this.resetList();
      },
      onChangeGuestCustActive(type) {
        this.isGuestCustActive = type;
        this.resetList();
      },
      onChangeFilterIsActiveOnlyTransaction(type) {
        this.is_transaction_filter = type;
        if (type == 1) {
          this.is_transaction_filter_label = "With Transaction";
        } else if (type == 2) {
          this.is_transaction_filter_label = "Without Transaction";
        } else {
          this.is_transaction_filter_label = "All Transaction";
        }

        this.resetList();
      },
      gotoNewTransaction(customer) {
        if (customer.is_guest_user == "N") {
          this.goToTransaction(customer.cust_id);
        } else {
          this.goToTransactionGuest(customer.guest_id);
        }
      },
      goToTransaction(cust_id) {
        this.$router.push({
          path: "/cinema-manager/view-customer-transaction",
          query: { cust_id: cust_id },
        });
      },
      goToTransactionGuest(guest_id) {
        console.log("guest_id", guest_id);
        this.$router.push({
          path: "/cinema-manager/view-guest-transaction",
          query: { guest_id: guest_id },
        });
      },
      //Sort
      getCustomersList: function() {
        let loader = this.$loading.show();
        this.customers = [];
        // MarketingService.getAllCustomerGuestListV2(
        //   this.perPage,
        //   this.currentPage,
        //   this.columnName,
        //   this.orderby,
        //   this.searchValue,
        //   "Y",
        //   this.listType,
        //   this.is_transaction_filter,
        //   this.fromDate ? this.fromDate : "",
        //   this.toDate ? this.toDate : ""
        // )
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          columnName: this.columnName,
          orderBy: this.orderby,
          searchValue: this.searchValue,
          filter_is_active: "Y",
          user_type: this.listType,
          fromDate: this.fromDate ? this.fromDate : "",
          toDate: this.toDate ? this.toDate : "",
          includeGuests: this.includeGuests || "",
          is_cust_guest_active: this.isGuestCustActive,
        };
        MarketingService.getAllCustomerGuestListV2(payload)
          .then((response) => {
            // console.log("response :", response);
            const { data } = response;
            //console.log("data", data);
            // console.log("data.Records :", data.Records);
            if (
              data &&
              data.hasOwnProperty("totalRows") &&
              this.currentPage == 1
            ) {
              this.rows = data.totalRows;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
            if (data && data.Records.length > 0) {
              // this.customers = data.Records;
              this.customers = data.Records;
              // this.social_login_details = this.customers.social_login_details;

              // console.log(
              //   this.social_login_details,
              //   "this.social_login_details"
              // );
              this.customerCopy = data.Records;
              // console.log("this.offername :", this.offername);
              // this.rows = data.totalRows;
            }

            // this.showCustomers();
            // setTimeout(() => loader.hide(), 100);
          })
          .catch((err) => {
            console.log("Error", err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      onViewCustomer: function(customer) {
        this.$router.push({
          path: "/marketing/view-Customers",
          query: { cust_id: customer.cust_id },
        });
        // console.log("institute_id ++++++++ :", offer);
      },
      onEditCustomer: function(customer) {
        this.$router.push({
          path: "/marketing/edit-Customers",
          query: { cust_id: customer.cust_id },
        });
        // console.log("bank_id :", bank.bank_id);
      },
      goToFlow(cust_id) {
        this.$router.push({
          name: "View User Journey Flow",
          params: { cust_id: cust_id },
        });
      },

      onChangePagination: function(event) {
        // let loader = this.$loading.show();

        if (event === undefined) {
          this.currentPage = 1;
          this.getCustomersList();
          // setTimeout(() => loader.hide(), 100);
        } else {
          this.currentPage = event;
          this.getCustomersList();
        }
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.resetList();
        } else {
          // console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          // console.log("perPage :", this.perPage);
          this.resetList();
        }
      },
    },
  };
</script>
<style scoped>
  .list-view-table th:first-child {
    padding-left: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CustomersComponents/customers.vue